module.exports = __webpack_public_path__ + "static/media/so-end-slide-cy.284508df.svg";